import { NextSeo } from 'next-seo'
import useUser from '../../lib/useUser'
import JsonLd from './JsonLd'

export default function Meta({
  title: inputTitle,
  jsonLd,
  canonical,
  openGraph,
  ...props
}) {
  const title = useTitle(inputTitle)

  return (
    <>
      <NextSeo
        title={title}
        canonical={canonical}
        openGraph={{
          ...openGraph,
          title: openGraph?.title || title,
        }}
        {...props}
      />
      {jsonLd && <JsonLd data={jsonLd} />}
    </>
  )
}

function useTitle(inputTitle) {
  const { isAuthed, user } = useUser()

  if (isAuthed && user != null && user.unread_notifications_count > 0) {
    return `(${user.unread_notifications_count}) ${inputTitle}`
  }

  return inputTitle
}
